<template>
    <div class="text-bubble">
        <div
            ref="content" class="content"
            :class="[
                background ? `${background}-background` : '',
                speechTail ? `${speechTail}-speech-tail` : '',
            ]"
        >
            <slot />
        </div>
    </div>
</template>

<script>
import gsap from 'gsap';

export default {
    name: 'TextBubble',
    props: {
        background: {
            type: String,
            default: 'white'
        },
        speechTail: {
            type: String,
            default: ''
        },
        initialShow: {
            type: Boolean,
            default: false
        }
    },
    mounted()
    {
        if (this.initialShow === true)
        {
            this.show();
        }
    },
    methods: {
        show(onComplete)
        {
            const {$refs} = this;
            gsap.timeline({onComplete})
                .fromTo(
                    $refs.content,
                    {scale: 0.5, opacity: 0},
                    {duration: 1.2, scale: 1, opacity: 1, ease: 'elastic.out(1.1, 0.9)'},
                    0.1
                );
        },
        hide(onComplete)
        {
            const {$refs} = this;
            gsap.timeline({onComplete})
                .fromTo(
                    $refs.content,
                    {scale: 1, opacity: 1},
                    {duration: 0.3, scale: 0.5, opacity: 0},
                    0.1
                );
        }
    }
};
</script>

<style lang="scss" src="./SpeechBubble.scss" />

